import { AvailabilityIndicator, Domains, FiberConnectedIndicator, FiberFootprints, JarvisSuggestionType } from '../enum';
import { JarvisProduct, JarvisSuggestion } from '../interface';
import { isWholebuy } from './typeGuard';

/**
 * Check if Jarvis Suggested Item is Wholebuy (DTAG or DGW) .
 *
 * @param {JarvisSuggestion} Suggestion - Suggestion Object to check against.
 * @returns {boolean} True if Jarvis Suggestion is Fiber Wholebuy.
 */

export const isFiberWholebuy = (Suggestion:JarvisSuggestion) =>
    Suggestion?.type === JarvisSuggestionType.FIBER && isWholebuy(Suggestion?.product?.accessSupplier);

/**
 * Check if Jarvis Suggested Product is Fiber OXG .
 * @param Suggestion - Suggestion Object from jarvis
 * @returns
 */
export const isFiberOXG = (Suggestion:JarvisSuggestion) =>
    Suggestion?.type === JarvisSuggestionType.FIBER && Suggestion?.product?.accessSupplier === FiberFootprints.OXG;

/**
 * Check if Jarvis Suggested Product is Fiber OXG and Connected (GRUEN)
 * @param Suggestion - Suggestion Object from jarvis
 * @returns
 */
export const isOXGandConnected = (Suggestion:JarvisSuggestion) =>
    isFiberOXG(Suggestion) && Suggestion.product?.availabilityIndicator === FiberConnectedIndicator.CONNECTED;

/**
 * Check if Jarvis product is In Construction Phase .
 *
 * @param {JarvisProduct} Product - Jarvis Product to check against.
 * @returns {boolean} True if Jarvis Product is in Construction Phase (availabilityIndicator = 'GELB_GRAU' or 'ORANGE').
 */
export const isProductInConstructionPhase = (Product:JarvisProduct )=>{
    return Product?.availabilityIndicator === AvailabilityIndicator.PRE_SALES || Product?.availabilityIndicator === AvailabilityIndicator.HOME_PASSED;
};
/*
* @returns True if the current environment is ST
*/
/**
 *
 */
export const isStagingEnv = () => window.location.origin === Domains.ST;
